/* eslint-disable react-hooks/exhaustive-deps */

import React, { ReactElement, useEffect, useState } from 'react'
import { RichTextEditor } from '@mantine/rte'

import { StyledTextAdmin } from './styled-components'
import { useAddTextAdminContext } from '../../../../contexts/add-text-admin'
import Icon from '../../../icon'
import Button from '../../../button'

interface TextAdminProps {
  id: number
  value: string

  onDeleteClick?: () => void
}

function TextAdmin({ id, value, onDeleteClick }: TextAdminProps): ReactElement {
  const { addTextAdmin, setAddTextAdmin } = useAddTextAdminContext()
  const [text, setText] = useState(value)
  useEffect(() => {
    if (text) {
      const oldSections = [...addTextAdmin]
      const findIndexSection = oldSections.findIndex((e) => e.id === id)
      oldSections[findIndexSection].value = text
      setAddTextAdmin(oldSections)
    }
  }, [text])

  return (
    <StyledTextAdmin>
      <RichTextEditor dir="rtl" value={text} onChange={setText} />
      {onDeleteClick ? (
        <Button onClick={onDeleteClick} color="white">
          <Icon width={20} height={20} name="fluent:delete-28-regular" />
        </Button>
      ) : (
        <></>
      )}
    </StyledTextAdmin>
  )
}

export default TextAdmin
